import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import DisciplinaryCaseServices from "./disciplinary_case.services";
import wFlowEmpleadosServices from "../../on&offBoarning/Mantenimientos/WorkFlowEmp/wFlowEmpleados.services";
import { downloadDocument } from "../../../components/gestorDocumental/GestorDocumental";

export const getDisciplinaryCases = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASES,
      payload: true,
    });
    const resp = await DisciplinaryCaseServices.getDisciplinaryCases(filters);
    dispatch({
      type: actions.GET_DISCIPLINARY_CASES,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASES,
      payload: null,
    });
    dispatch({
      type: actions.FORM_DISCIPLINARY_CASE_FAILD,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASES,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASES,
      payload: false,
    });
  }
};

export const getDisciplinaryCasesAll = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASES_ALL,
      payload: true,
    });
    const resp = await DisciplinaryCaseServices.getDisciplinaryCases(filters);
    dispatch({
      type: actions.GET_DISCIPLINARY_CASES_ALL,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASES_ALL,
      payload: null,
    });
    // dispatch({
    //   type: actions.FORM_DISCIPLINARY_CASE_FAILD,
    //   payload: null,
    // });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASES_ALL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASES_ALL,
      payload: false,
    });
  }
};

export const getDisciplinaryCase = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASE,
      payload: true,
    });
    const resp = await DisciplinaryCaseServices.getDisciplinaryCase(id);
    dispatch({
      type: actions.GET_DISCIPLINARY_CASE,
      payload: resp.data,
    });
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASE,
      payload: null,
    });
    // toastr.success(messages.successMessage, '', {
    //   progressBar: true,
    //   rtl: true,
    // });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASE,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASE,
      payload: false,
    });
  }
};

export const resetDisciplinaryCase = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASE,
      payload: true,
    });
    dispatch({
      type: actions.GET_DISCIPLINARY_CASE,
      payload: null,
    });
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASE,
      payload: null,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILD_DISCIPLINARY_CASE,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_DISCIPLINARY_CASE,
      payload: false,
    });
  }
};

export const saveDisciplinaryCase =
  (data, setShowModal, _estatus, file, _getDisciplinaryCases) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_DISCIPLINARY_CASE,
        payload: true,
      });
      const resp = await DisciplinaryCaseServices.saveDisciplinaryCase(data);
      let _resp = resp;
      const { disciplinaryCases } = getState().disciplinaryCase;
      if (file && file.length > 0) {
        for (let i = 0; i < file.length; i++) {
          const dataUrl = new FormData();
          dataUrl.append("caso_disciplinario", _resp.data.id);
          // dataUrl.append("id", resp.data.caso_disciplinario);
          dataUrl.append("nombre_archivo", file[i].name);
          dataUrl.append("archivo", file[i]);
          await DisciplinaryCaseServices.saveRequirementsUrl(dataUrl);
        }
      }

      // dispatch({
      //   type: actions.GET_DISCIPLINARY_CASES,
      //   payload: {
      //     count: disciplinaryCases.count + 1,
      //     data: [...disciplinaryCases.data, _resp.data]
      //   },
      // });
      _getDisciplinaryCases();
      if (
        _resp.data &&
        _resp.data.list_id_usuario &&
        data.id_responsable_off &&
        data.id_workflow
      ) {
        const reqWF = {
          empleados: [
            {
              empleado: _resp.data.list_id_usuario[0].id,
              responsable: data.id_responsable_off,
            },
          ],
          workflow: data.id_workflow,
        };
        const _reqWF = await wFlowEmpleadosServices.saveWorkFlowEmp(reqWF);
        if (
          _reqWF &&
          _reqWF.data &&
          _reqWF.data.resultado &&
          _reqWF.data.resultado.length > 0
        ) {
          _resp.data.off_bording = _reqWF.data.resultado[0].workflow;
          await DisciplinaryCaseServices.editDisciplinaryCase(
            _resp.data.id,
            _resp.data
          );
          dispatch({
            type: actions.GET_DISCIPLINARY_CASES,
            payload: {
              count: disciplinaryCases.count + 1,
              data: [...disciplinaryCases.data, _resp.data],
            },
          });
        }
      }
      dispatch({
        type: actions.FORM_DISCIPLINARY_CASE_FAILD,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      setShowModal(false);
      const _data = {
        data: [
          {
            caso_disciplinario_id: resp.data.id,
            tipo_mensaje: "Jefe empleado-Caso disciplinario On",
          },
          {
            caso_disciplinario_id: resp.data.id,
            tipo_mensaje: "Jefe responsable sanciones-Caso disciplinario On",
          },
          {
            caso_disciplinario_id: resp.data.id,
            tipo_mensaje: "Encargado sanciones-Asignar caso disciplinario",
          },
        ],
      };
      await DisciplinaryCaseServices.envioCorreo(_data);
      if (_estatus.nombre.toLowerCase() === "cerrado") {
        const _dataT = {
          data: [
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Jefe empleado-Caso disciplinario Off",
            },
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Jefe responsable sanciones-Caso disciplinario Off",
            },
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Encargado caso-Caso disciplinario Off",
            },
          ],
        };
        await DisciplinaryCaseServices.envioCorreo(_dataT);
      }
      if (
        _resp.data.list_codigo_empleado &&
        _resp.data.list_codigo_empleado[0].conteo_casos &&
        _resp.data.list_codigo_empleado[0].conteo_casos > 2
      ) {
        const _dataO = {
          data: [
            {
              empleado_id: resp.data.codigo_empleado,
              tipo_mensaje: "Jefe empleado-Tres o mas casos creados",
            },
            {
              empleado_id: resp.data.codigo_empleado,
              tipo_mensaje: "Jefe responsable sanciones-Tres o mas casos On",
            },
            {
              empleado_id: resp.data.codigo_empleado,
              tipo_mensaje: "Responsable modulo sanciones-Tres o mas casos On",
            },
          ],
        };
        await DisciplinaryCaseServices.envioCorreo(_dataO);
      }
      toastr.success(messages.correoEnviado, "", {
        progressBar: true,
        rtl: true,
      });

      return _resp.data.id;
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_DISCIPLINARY_CASE_FAILD,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_DISCIPLINARY_CASE,
        payload: false,
      });
    }
  };

export const editDisciplinaryCase =
  (
    data,
    editItem,
    index,
    setShowModal,
    _estatus,
    file,
    _getDisciplinaryCases
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADER_DISCIPLINARY_CASE,
        payload: true,
      });
      let resp = {};
      if (
        editItem &&
        editItem.list_id_usuario &&
        data.id_responsable_off &&
        data.id_workflow
      ) {
        const reqWF = {
          empleados: [
            {
              empleado: editItem.list_id_usuario[0].id,
              responsable: data.id_responsable_off,
            },
          ],
          workflow: data.id_workflow,
        };
        const _reqWF = await wFlowEmpleadosServices.saveWorkFlowEmp(reqWF);
        if (
          _reqWF &&
          _reqWF.data &&
          _reqWF.data.resultado &&
          _reqWF.data.resultado.length > 0
        ) {
          const objTemp = {
            off_bording: _reqWF.data.resultado[0].workflow,
          };
          const _data = Object.assign(data, objTemp);
          resp = await DisciplinaryCaseServices.editDisciplinaryCase(
            editItem.id,
            _data
          );
        } else {
          resp = await DisciplinaryCaseServices.editDisciplinaryCase(
            editItem.id,
            data
          );
        }
      } else {
        resp = await DisciplinaryCaseServices.editDisciplinaryCase(
          editItem.id,
          data
        );
      }
      const { disciplinaryCases } = getState().disciplinaryCase;
      let _disciplinaryCasesData = disciplinaryCases.data.slice();
      _disciplinaryCasesData[index] = resp.data;
      if (file && file.length > 0) {
        for (let i = 0; i < file.length; i++) {
          const dataUrl = new FormData();
          dataUrl.append("caso_disciplinario", resp.data.id);
          // dataUrl.append("caso_disciplinario", resp.data.caso_disciplinario);
          dataUrl.append("nombre_archivo", file[i].name);
          dataUrl.append("archivo", file[i]);
          await DisciplinaryCaseServices.saveRequirementsUrl(dataUrl);
        }
      }
      // dispatch({
      //   type: actions.GET_DISCIPLINARY_CASES,
      //   payload: {
      //     count: disciplinaryCases.count,
      //     data: _disciplinaryCasesData
      //   },
      // });
      _getDisciplinaryCases();
      dispatch({
        type: actions.FORM_DISCIPLINARY_CASE_FAILD,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
      setShowModal(false);
      if (data.id_encargado !== editItem.id_encargado) {
        const _dataR = {
          data: [
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Encargado sanciones-Asignar caso disciplinario",
            },
          ],
        };
        await DisciplinaryCaseServices.envioCorreo(_dataR);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
      if (_estatus.nombre.toLowerCase() === "cerrado") {
        const _data = {
          data: [
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Jefe empleado-Caso disciplinario Off",
            },
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Jefe responsable sanciones-Caso disciplinario Off",
            },
            {
              caso_disciplinario_id: resp.data.id,
              tipo_mensaje: "Encargado caso-Caso disciplinario Off",
            },
          ],
        };
        await DisciplinaryCaseServices.envioCorreo(_data);
        toastr.success(messages.correoEnviado, "", {
          progressBar: true,
          rtl: true,
        });
      }
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data;
              break;
            case 404:
              if (ex.response.data && ex.response.data.mensaje) {
                message = ex.response.data.mensaje;
              } else {
                message = messages.notFound;
              }
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FORM_DISCIPLINARY_CASE_FAILD,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADER_DISCIPLINARY_CASE,
        payload: false,
      });
    }
  };

export const deleteDisciplinaryCase =
  (id, index) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADER_DISCIPLINARY_CASES,
        payload: true,
      });
      await DisciplinaryCaseServices.deleteDisciplinaryCase(id);
      const { disciplinaryCases } = getState().disciplinaryCase;
      let _disciplinaryCasesData = disciplinaryCases.data.slice();
      _disciplinaryCasesData.splice(index, 1);
      dispatch({
        type: actions.GET_DISCIPLINARY_CASES,
        payload: {
          data: _disciplinaryCasesData,
          count: disciplinaryCases.count - 1,
        },
      });
      dispatch({
        type: actions.FAILD_DISCIPLINARY_CASES,
        payload: null,
      });
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = ex.response.data.mensaje;
              break;
            case 404:
              message = messages.notFound;
              break;
            default:
              message = messages.errorMessage;
              break;
          }
        } else {
          message = messages.networkError;
        }
      } else {
        message = messages.applicationError;
      }
      dispatch({
        type: actions.FAILD_DISCIPLINARY_CASES,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADER_DISCIPLINARY_CASES,
        payload: false,
      });
    }
  };

export const getComments = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADER_COMMENTS,
      payload: true,
    });
    const resp = await DisciplinaryCaseServices.getComments(id);
    dispatch({
      type: actions.GET_COMMENTS,
      payload: resp.data,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.FAILD_COMMENTS,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADER_COMMENTS,
      payload: false,
    });
  }
};

export const postComment = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.CREATE_COMMENT_LOADER,
      payload: true,
    });
    const resp = await DisciplinaryCaseServices.postComment(data);
    dispatch({
      type: actions.CREATE_COMMENT,
      payload: resp.data,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            message = messages.notFound;
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError;
    }
    dispatch({
      type: actions.CREATE_COMMENT_FAILD,
      payload: message,
    });
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.CREATE_COMMENT_LOADER,
      payload: false,
    });
  }
};

export const resetComments = () => ({
  type: actions.RESET_COMMENTS,
});

export const getRequirementDoc =
  (id, setLoader) => async (dispatch, getState) => {
    try {
      // dispatch({
      //   type: actions.LOADING_DESCRIPTOR_MANUAL,
      //   payload: true,
      // });
      setLoader(true);
      const resp = await DisciplinaryCaseServices.getRequirementDoc(id);
      downloadDocument(
        `data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,${resp.data.documento}`,
        "Solicitud plaza.docx"
      );
      toastr.success(messages.successMessage, "", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      // dispatch({
      //   type: actions.FORM_FAIL_GENERAL_INFO,
      //   payload: message,
      // });
      toastr.error(message, "", {
        progressBar: true,
        rtl: true,
      });
    } finally {
      setLoader(false);
      // dispatch({
      //   type: actions.LOADING_DESCRIPTOR_MANUAL,
      //   payload: false,
      // });
    }
  };
